import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  tableHeader: {
    backgroundColor: '#E4E6E8',
  },
  tableRow: {
    backgroundColor: '#f4f6f8',
    width: '100%',
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    padding: theme.spacing(2),
    paddingTop: theme.spacing(3),
  },
}))

export default useStyles
